// @ts-nocheck

import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getEventDetails } from 'Redux/selectors/influencer'
import { Desktop } from 'Shared/components/Responsive'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { IconTikTok } from 'Stories/Icon/Icon.stories'
import { ButtonsGroups } from '../styles'
import { StyledButton } from './styles'
import { AwaitingProps } from './types'

export const Awaiting: FunctionComponent<AwaitingProps> = ({ t, onClose }) => {
  const eventDetails = useSelector(getEventDetails)

  return (
    <ButtonsGroups>
      <Desktop>
        <GreenBtn color="white" onClick={onClose}>
          {t('influencer.closeBtn')}
        </GreenBtn>
      </Desktop>
      <Link
        to={{
          pathname: eventDetails?.tiktokVideoUrl,
        }}
        target="_blank"
      >
        <StyledButton color="whiteGreen">
          <IconTikTok />
          {t('influencer.videoOnTiktok')}
        </StyledButton>
      </Link>
    </ButtonsGroups>
  )
}
